/** Відео за прямим шляхом: .../file_storage/{uuid}.mp4 */
export const MEDIA_SERVER_VIDEO_FILE_EXT = '(?:mp4|webm|mov|m4v|mkv|avi)'

/**
 * File storage (JWT у заголовку — blob у плеєрі).
 * Підтримка: .../file_storage/{id}/download та .../file_storage/{uuid}.mp4
 */
export function isMediaServerVideoUrl(url) {
    if (!url || typeof url !== 'string') return false
    const t = url.trim()
    if (/file_storage\/[^/?#]+\/download/i.test(t)) return true
    return new RegExp(
        `file_storage/[^?#]+\\.${MEDIA_SERVER_VIDEO_FILE_EXT}(?:[?#]|$)`,
        'i'
    ).test(t)
}

/**
 * Build absolute API URL for stored link (DB may have full URL or path-only).
 */
export function resolveMediaFileDownloadUrl(url) {
    if (!url || typeof url !== 'string') return ''
    const t = url.trim()
    if (/^https?:\/\//i.test(t)) return t
    const base = (process.env.VUE_APP_API_URL || '').replace(/\/*$/, '/')
    const path = t.startsWith('/') ? t.slice(1) : t
    return base + path
}

/**
 * YouTube / Shorts links (vue3-youtube).
 * Media-server URLs must win if the path accidentally contains "youtube" as a segment.
 */
export function isYouTubeVideoUrl(url) {
    if (!url || typeof url !== 'string') return false
    if (isMediaServerVideoUrl(url)) return false
    return /youtube\.com|youtu\.be/i.test(url.trim())
}

/**
 * Extract YouTube video id for thumbnails / embeds.
 */
export function getYouTubeVideoId(url) {
    if (!url || typeof url !== 'string') return null
    const trimmed = url.trim()
    let m = trimmed.match(/youtu\.be\/([^/?&#]+)/i)
    if (m) return m[1]
    m = trimmed.match(/[?&]v=([^&#]+)/i)
    if (m) return m[1]
    m = trimmed.match(/youtube\.com\/embed\/([^/?&#]+)/i)
    if (m) return m[1]
    m = trimmed.match(/youtube\.com\/shorts\/([^/?&#]+)/i)
    if (m) return m[1]
    return null
}
